<template>
  <div class="app">
    <AppHeader ref="header" v-on:OpenSettings="onOpenSettings" />
    <div class="app-body">
      <Sidebar ref="Sidebar" />
      <main class="main">
        <div v-if="removeContainer" class="h-100">
          <router-view />
        </div>
        <div v-else class="h-100">
          <breadcrumb :list="list" />
          <div class="container-fluid h-100" style="overflow: hidden;">
            <router-view />
          </div>
        </div>
      </main>
      <AppAside />
    </div>
    <AppFooter />

    <NxFloatingButton
      v-if="hasMesa"
      :action="onShowAtendimento"
      :position="{ bottom: '50px', right: '20px' }"
    />

    <AtendimentoSenhas v-if="hasMesa" />
  </div>
</template>

<script>
import AppHeader from '@/containers/layout/Header'
import Sidebar from '@/containers/layout/Sidebar'
import AppAside from '@/containers/layout/Aside'
import AppFooter from '@/containers/layout/Footer'
import Breadcrumb from '@/containers/layout/Breadcrumb'

import AccountMixin from '@/store/module/account/mixin'
import NxFloatingButton from '../components/nexum/components/buttons/NxFloatingButton.vue'
import AtendimentoSenhas from '../views/private/nxSenhas/atendimento/AtendimentoSenhas.vue'
import MesaRepository from '../shared/http/repositories/nxSenhas/mesa'

export default {
  name: 'full',
  mixins: [
    AccountMixin
  ],
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    NxFloatingButton,
    AtendimentoSenhas
  },
  data () {
    return {
      showAtendimento: false,
      hasMesa: false
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.fullPath.split('/')
    },
    removeContainer () {
      return this.$route.meta && this.$route.meta.hasOwnProperty('removeContainer') && this.$route.meta.removeContainer
    }
  },
  watch: {
    $route () {
      if (this.$route.meta && this.$route.meta.hasOwnProperty('removeContainer')) {
        this.meta = this.$route.meta
      } else {
        this.meta = null
      }
      this.$forceUpdate()
    },
    'account.id': {
      handler (newVal) {
        if (newVal) {
          this.getLogged()
          this.checkAtendimentosEmEspera()
        }
      },
      immediate: true
    }
  },
  created () {
    this.getLogged()
    this.checkAtendimentosEmEspera()
  },
  methods: {
    routeIs (route) {
      return this.$route.name === route
    },
    onOpenSettings () {
      this.$refs.Sidebar.showMenuSetting()
    },
    onShowAtendimento () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-Atendimento')
    },
    async checkAtendimentosEmEspera () {
      try {
        if (this.account && this.account.id) {
          const response = await MesaRepository.GetByUsuario(this.account.id)
          this.hasMesa = response.data.length > 0
        } else {
          this.hasMesa = false
        }
      } catch (error) {
        console.error('Erro ao verificar atendimentos em espera:', error)
        this.hasMesa = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/PrivateBaseLayout.vue